"use client"

import { ThemeDivider } from "../terra/component/ThemeDivider/ThemeDivider"
import { LayoutCards } from "../terra/layouts/LayoutCards/LayoutCards"
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import { handleButtons } from "@/lib/utils"
import { safeSlug } from "@/lib/utils"

function normalizeEntryToCard(entry: any, lang: string) {
  const typeName = entry?.__typename
  let title = entry?.title
  let description = ""
  let imageUrl = ""
  let slug = ""

  if (typeName === "Article") {
    slug = `/${lang}/article/${safeSlug(entry?.slug)}`
    description =
      entry?.articleSummary || entry?.articleSeo?.teaserDescription || ""
    imageUrl =
      entry?.articleSeo?.teaserImage?.url || entry?.teaserImage?.url || ""
  } else if (typeName === "CaseStudy") {
    slug = `/${lang}/case-study/${safeSlug(entry?.slug)}`
    description = entry?.caseStudySeo?.teaserDescription || ""
    imageUrl = entry?.caseStudySeo?.teaserImage?.url || ""
  } else if (typeName === "Video") {
    title = entry?.videoTitle
    slug = `/${lang}/video/${safeSlug(entry?.slug)}`
    description = entry?.seo?.teaserDescription || ""
    imageUrl = entry?.seo?.teaserImage?.url || ""
  } else if (typeName === "Document") {
    slug = `/${lang}/docs/${safeSlug(entry?.slug)}`
    description = entry?.seo?.teaserDescription || ""
    imageUrl = entry?.seo?.teaserImage?.url || ""
  } else if (typeName === "ExternalResource") {
    title = entry?.displayTitle
    slug = entry?.externalResourceLink || ""
    description = entry?.seo?.teaserDescription || ""
    imageUrl = entry?.seo?.teaserImage?.url || ""
  }

  return {
    eyebrow:
      typeName === "CaseStudy"
        ? "Case Study"
        : typeName === "Video"
          ? "Video"
          : typeName === "Document"
            ? "Document"
            : typeName === "ExternalResource"
              ? "Resource"
              : "Article",
    header: title || "",
    description: description || "",
    button: slug
      ? { label: "Read More", destination: slug, primary: false }
      : undefined,
    image: imageUrl
      ? { url: imageUrl.split("?")[0], alt: title || "" }
      : undefined,
  }
}

export default function MXPLayoutDynamicCards(props: any) {
  const { value, index, divider, lang, headerElement } = props

  const buttons: any[] = handleButtons(value.buttonsCollection?.items, true, lang)
  const dynamicCards = value.dynamicCards || []

  const cards = dynamicCards
    .filter((entry: any) => entry != null)
    .map((entry: any) => normalizeEntryToCard(entry, lang || "en"))

  const dividerClasses = `section-divider-wrap ${value.theme}`
  return (
    <>
      <LayoutCards
        key={index}
        headerElement={headerElement}
        eyebrow={value.eyebrow}
        header={value.header}
        subheader={value.subheader}
        description={documentToHtmlString(value?.description?.json)}
        presetTheme={value.theme}
        cards={cards}
        cardType={"bound"}
        buttons={buttons}
        isWrapped={true}
        isHeaderBig={value.isHeaderBig || false}
      />
      {divider && (
        <div className={dividerClasses}>
          <ThemeDivider currentTheme={value.theme} />
        </div>
      )}
    </>
  )
}
